module.exports = __webpack_public_path__ + "img/dash2.2b920e57.png";